import { render } from "./Index.vue?vue&type=template&id=7c19bb61&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7c19bb61&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c19bb61"]])

export default __exports__